import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { sdkTypes } from '@vansite/ts-sharetribe-flex-sdk';
import React from 'react';
import { useIntl } from 'react-intl';

import { formatMoney } from '../../../util/currency';
import { FormattedMessage } from '../../../util/reactIntl';
import { LINE_ITEM_PROVIDER_COMMISSION, LINE_ITEM_PROVIDER_NIGHTLY_COMMISSION } from '../../../util/types';
import { itemValueStyles, lineItemStyles } from './BookingBreakdown.styles';

const { Money } = sdkTypes;

// Validate the assumption that the commission exists and the amount
// is zero or negative.
const isValidCommission = (commissionLineItem) => {
  return commissionLineItem.lineTotal instanceof Money && commissionLineItem.lineTotal.amount <= 0;
};

const LineItemProviderCommissionMaybe = ({ transaction, isProvider }) => {
  const intl = useIntl();

  if (!isProvider) return null;

  const providerCommissionLineItem = transaction.attributes.lineItems.find(
    (item) => item.code === LINE_ITEM_PROVIDER_COMMISSION && !item.reversal && item.lineTotal.amount < 0,
  );

  const providerNightlyCommissionLineItem = transaction.attributes.lineItems.find(
    (item) => item.code === LINE_ITEM_PROVIDER_NIGHTLY_COMMISSION && !item.reversal && item.lineTotal.amount < 0,
  );

  // If commission is passed it will be shown as a fee already reduces from the total price
  let commissionItem = null;

  // Flex Template for Web is using the default transaction process (https://www.sharetribe.com/docs/background/transaction-process/#sharetribe-flex-default-transaction-process)
  // which containt provider commissions so by default the providerCommissionLineItem should exist.
  // If you are not using provider commisison you might want to remove this whole component from BookingBreakdown.js file.
  if (isProvider && (providerCommissionLineItem || providerNightlyCommissionLineItem)) {
    if ((providerCommissionLineItem && !isValidCommission(providerCommissionLineItem)) || (providerNightlyCommissionLineItem && !isValidCommission(providerNightlyCommissionLineItem))) {
      throw new Error('Commission should be present and the value should be zero or negative');
    }

    const commission =
      providerCommissionLineItem?.lineTotal ||
      new Money(0, providerNightlyCommissionLineItem.lineTotal.currency);
    const nightlyCommission =
      providerNightlyCommissionLineItem?.lineTotal ||
      new Money(0, providerCommissionLineItem.lineTotal.currency);
    const totalCommission = new Money(
      commission.amount + nightlyCommission.amount,
      commission.currency || nightlyCommission.currency,
    );
    const formattedCommission = commission ? formatMoney(intl, totalCommission) : null;

    commissionItem = (
      <Box sx={lineItemStyles}>
        <Typography sx={{ flex: 1 }} variant="lineItemLabel">
          <FormattedMessage id="BookingBreakdown.commission" />
        </Typography>
        <Typography sx={itemValueStyles} variant="lineItemLabel">{formattedCommission}</Typography>
      </Box>
    );
  }

  return commissionItem;
};

export default LineItemProviderCommissionMaybe;
